import api, { unwrap } from './api';
import type { DashboardKpis } from '../types';

export const dashboardService = {
  get: () => api.get('admin/dashboard').then(unwrap<DashboardKpis>),
};
